import { Cookies } from 'react-cookie';

interface CookieOptions {
  path?: string;
  expires?: Date;
  maxAge?: number;
  domain?: string;
  secure?: boolean;
  sameSite?: boolean | 'none' | 'lax' | 'strict';
}

const cookies = new Cookies();

const getCookie = (token: string) => {
  if (cookies.get(token)) {
    return cookies.get(token);
  } else {
    return null;
  }
};

const setAccessToken = (token: string, option?: CookieOptions) => {
  return cookies.set('Authorization', token, { maxAge: 604800, path: '/', ...option });
};

const setRefreshToken = (token: string, option?: CookieOptions) => {
  return cookies.set('RefreshToken', token, { maxAge: 604800, path: '/', ...option });
};

const deleteCookie = (token: string, option?: CookieOptions) => {
  return cookies.remove(token, { path: '/', ...option });
};

export { getCookie, setAccessToken, setRefreshToken, deleteCookie };
